import "./index.scss";

const Footer = () => {
  return (
    <footer className="site-footer">
      © {new Date().getFullYear()} NeverOwned. All rights reserved.
    </footer>
  );
};

export default Footer;
